import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HelpToolTip from '../../../../../Common/HelpToolTip';
import ContractTemplateDatatable from '../../Datatables/ContractTemplateDatatable';
import ViewAlert from '../../Components/ViewAlert/ViewAlert';
import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';
import Columns from '../../Datatables/ColumnDefinitions';
import {
	saveUpdatedContractTemplates,
	getContractTemplates,
	addUpdateToTemplates,
	clearUpdateTemplateErrors,
	clearAllTemplatesUpdates,
	removeUpdate,
	removeAllEdits
} from '../../../../../Redux/Actions/Contract.Templates.Actions';
import BackButton from 'Common/CloseButton/CloseButton';
import Page from 'Common/Layout/Page';
import SaveButton from '../../Components/SaveButton/SaveButton';
import classes from '../contract-views.module.css';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const TemplatesManagement = withClsCompTracking('Templates Management Table')(ContractTemplateDatatable);

const ContractTemplates = ({ handleActiveModal, appointeeType = 'Marker' }) => {
	document.title = `Contract Template Initialisation (${appointeeType})`
	const { selected: qualYear } = useSelector(qualYearSelect);	
	const dispatch = useDispatch();
	const [fireShow, setFireShow] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const templates = useSelector(state => state.templates);
    const handleGetContractTemplates = (appointeeType, activeStatus, qualYear, query) => dispatch(getContractTemplates(appointeeType, activeStatus, qualYear, query));
	const handleTemplateUpdate = (field, value, row, updates) =>
		dispatch(addUpdateToTemplates(field, value, row, updates));
	const handleSaveContractTemplates = (appointeeType, activeStatus, query, data) =>
		dispatch(saveUpdatedContractTemplates(appointeeType, activeStatus, query, data));
	const handleClearTemplatesUpdates = () => dispatch(clearAllTemplatesUpdates());
	const handleTemplateErrorClear = () => dispatch(clearUpdateTemplateErrors());
	const handleRemoveUpdate = (keyField, id, updates) => dispatch(removeUpdate(keyField, id, updates));
	const handleRemoveAllEdits = () => dispatch(removeAllEdits());

	const saveContractFees = () => {
		handleSaveContractTemplates(appointeeType, templates.activeStatus, templates.query, templates.updated);
		setFireShow(true);
	};

	const hasUpdates = templates?.updated?.length > 0 || false;
	const closeOnClick = () => handleActiveModal('');
	const amendments = templates.updated.length;

	return (
		<>
			<Page title={`Contract Template Initialisation (${appointeeType})`}>
			</Page>
			<HelpToolTip title={`Contract Template Editing Help`} />
			<ViewAlert show={templates.message !== ''} message={templates.message} errors={templates.errors} clearMessage={handleTemplateErrorClear} />
			<TemplatesManagement
				keyField={'id'}
				qualYear={qualYear.toString()}
				columns={Columns.ContractTemplatesColumns}
                handleGetData={handleGetContractTemplates}
				handleAddUpdates={handleTemplateUpdate}
				handleClearUpdates={handleClearTemplatesUpdates}
				removeUpdate={handleRemoveUpdate}
				handleRemoveAllEdits={handleRemoveAllEdits}
				appointeeType={appointeeType}
				fireShow={fireShow}
				setFireShow={setFireShow}
				editMode={editMode}
				setEditMode={setEditMode}
				amendments={amendments}
				dispatch={dispatch}
				{...templates}
			/>
			<span className={classes['action-buttons']}>
				<BackButton closeOnClick={closeOnClick} hasUpdates={hasUpdates} />
				{!editMode && <SaveButton saveOnClick={saveContractFees} disabled={ amendments === 0 } />}
			</span>
		</>
	);
};

export default ContractTemplates;
